import { combineReducers } from 'redux';

import TagManagementContainer from './components/TagManagementContainer';
import ContentTagsReducers from './reducers/ContentTagsReducers';
import CourseTagsReducers from './reducers/CourseTagsReducers';
import ContentTypeReducers from './reducers/ContentTypeReducers';

const components = { TagManagementContainer };

const reducers = combineReducers({
	contentTags: ContentTagsReducers,
	courseTags: CourseTagsReducers,
	contentType: ContentTypeReducers,
});

export { components, reducers };